/* eslint-disable react/jsx-no-duplicate-props */
import CloseIcon from '@mui/icons-material/Close';
import { Checkbox, Fab, InputAdornment, MenuItem, Radio, Switch, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import _ from 'lodash';
import * as React from 'react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import * as Yup from 'yup';

import CustomSimpleSelect from '../../../components/UI/CustomSimpleSelect';
import DateField from '../../../components/UI/DateField';
import FileImageView from '../../../components/UI/FileImageView';
import { createSafalEventUser, globalImagesUpload, updateSafalEventUser } from '../../../services/Service';
import { transformYupErrorsIntoArray } from '../../../utils/fn';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 900,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius: '8px',
  boxShadow: 24,
  displey: 'flex',
  maxHeight: '95vh',
  overflow: 'auto',
  flexDirection: 'column',
  gap: '12px',
  p: 4,
  '@media (max-width: 640px)': {
    width: '95vw',
    height: '95vh',
    overflow: 'auto',
  },
};

const validationSchema = Yup.object().shape({
  name: Yup.string().required('required'),
  date: Yup.string().required('required'),
  eventType: Yup.string().required('required'),
  type: Yup.string().required('required'),
});

const resetFieldValue = {
  name: '',
  date: '',
  status: 'Active', // Active/Inactive
  description: '',
  frequency: '', // optional day, week, month, year
  interval: 1,
  recurringEvent: false,
  targetedParticipants: '',
  venue: '',
  budget: '',
  customType: '',
  type: '',
  eventType: 'Private', // Private, Public
  // phoneNumber: '',
  // email: '',
  eventImage: [],
  locationUrl: '',
  notification: {
    // required
    email: false, // required , default = false
    text: false, // required , default = false
    mobileApp: false, // required , default = false
    notification: false, // required , default = false
    banner: false, // required , default = false
  },
};

export default function AddModal({ data, open, onClose, isDisplay, eventType }) {
  const { user } = useSelector((state) => state.login);
  const safalMyBuyState = useSelector((state) => state.safalMyBuyState);
  const globalToggleState = useSelector((state) => state.globalToggleState);
  const [currentStep, setCurrentStep] = React.useState(1);
  // const dispatch = useDispatch();

  const [fieldValue, setFieldValue] = React.useState({ ...resetFieldValue });
  const [fieldValueError, setFieldValueError] = React.useState([]);
  const [isDisableAll, setIsDisableAll] = React.useState(false);

  const [imagesFile, setImagesFile] = React.useState(null);
  const [syncWithSafalMyBuy, setSyncWithSafalMyBuy] = React.useState(false);

  const eventTypeList = eventType || [];

  const onCloseThis = (refetchFlag) => {
    setIsDisableAll(false);
    setFieldValue({ ...resetFieldValue });
    setFieldValueError([]);
    setImagesFile(null);
    setSyncWithSafalMyBuy(false);
    setCurrentStep(1);
    onClose(refetchFlag);
  };

  const updateFieldValue = data
    ? {
        name: data?.name ?? '',
        date: data?.date ?? '',
        status: data?.status ?? 'Active',
        description: data?.description ?? '',
        frequency: data?.frequency ?? '',
        interval: data?.interval ?? 1,
        recurringEvent: data?.recurringEvent ?? false,
        targetedParticipants: data?.targetedParticipants ?? '',
        venue: data?.venue ?? '',
        budget: data?.budget ?? '',
        eventType: data?.eventType ?? 'Private',
        type: data?.type?._id ?? '',
        customType: data?.customType ?? '',
        // phoneNumber: data?.phoneNumber ?? '',
        // email: data?.email ?? '',
        eventImage: data?.eventImage ?? [],
        locationUrl: data?.locationUrl ?? '',
        notification: {
          // required
          email: data?.notification?.email || false, // required , default = false
          text: data?.notification?.text || false, // required , default = false
          mobileApp: data?.notification?.mobileApp || false, // required , default = false
          notification: data?.notification?.notification || false, // required , default = false
          banner: data?.notification?.banner || false, // required , default = false
        },
      }
    : resetFieldValue;

  const handleClose = async (refetchFlag, directClose) => {
    if (isDisplay) {
      onCloseThis(refetchFlag);
      return;
    }
    if (directClose) {
      onCloseThis(refetchFlag);
      return;
    }

    if (_.isEqual(updateFieldValue, fieldValue)) {
      onCloseThis(refetchFlag);
      return;
    }
    const result = await Swal.fire({
      text: 'Are you sure you want to close this?',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
      appendTo: 'body',
      customClass: {
        container: 'my-swal', // Add a custom class for styling
      },
      onBeforeOpen: () => {
        // Set a higher zIndex for the Swal modal
        document.querySelector('.my-swal').style.zIndex = 999999;
      },
    });

    if (result.isConfirmed) {
      onCloseThis(refetchFlag);
    }
  };

  React.useEffect(() => {
    if (open === true && data !== null) {
      setFieldValue(updateFieldValue);
      setIsDisableAll(isDisplay);
      if (data?.safalMyBuyEventId) {
        setSyncWithSafalMyBuy(true);
      }
    }
  }, [open, data, isDisplay]);

  const onSubmit = async () => {
    setIsDisableAll(true);
    setFieldValueError([]);
    try {
      const payload = {
        ...fieldValue,
      };

      await validationSchema.validate(payload, { abortEarly: false, strict: false });

      if (imagesFile) {
        const fileRes = await globalImagesUpload([imagesFile], 'safal_event', 'private');
        if (!fileRes.data?.data?.[0]) throw new Error('upload failed');
        payload.eventImage = [fileRes.data?.data?.[0]];
      }

      const res = await createSafalEventUser({ ...payload, syncWithSafalMyBuy });
      if (res.status === 200) {
        toast.success(res.data.message);
        if (!res?.data?.webhookResult?.success) {
          toast.error(res?.data?.webhookResult?.message, {
            duration: 5000,
          });
        }
        handleClose(true, true);
      }
    } catch (err) {
      setFieldValueError(transformYupErrorsIntoArray(err));
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setIsDisableAll(false);
    }
  };

  const onUpdate = async () => {
    setIsDisableAll(true);
    setFieldValueError([]);
    try {
      const payload = {
        ...fieldValue,
      };

      if (imagesFile) {
        const fileRes = await globalImagesUpload([imagesFile], 'safal_event', 'private');
        if (!fileRes.data?.data?.[0]) throw new Error('upload failed');
        payload.eventImage = [fileRes.data?.data?.[0]];
      }

      const res = await updateSafalEventUser({ ...payload, _id: data._id, syncWithSafalMyBuy });
      if (res.status === 200) {
        toast.success(res.data.message);
        if (!res?.data?.webhookResult?.success) {
          toast.error(res?.data?.webhookResult?.message, {
            duration: 5000,
          });
        }
        handleClose(true, true);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setIsDisableAll(false);
    }
  };

  const amountSym = user.country === 'United States' ? '$' : '₹';

  const onNextPage = async (currentStep) => {
    if (currentStep === 1) {
      try {
        const payload = {
          ...fieldValue,
        };

        await validationSchema.validate(payload, { abortEarly: false, strict: false });

        setCurrentStep((prev) => prev + 1);
      } catch (err) {
        setFieldValueError(transformYupErrorsIntoArray(err));
        toast.error(err?.response?.data?.message || err.message);
      }
    } else {
      setCurrentStep((prev) => prev + 1);
    }
  };

  return (
    <>
      <Modal sx={{ zIndex: 345 }} open={open} onClose={handleClose}>
        <Box sx={style}>
          <Fab
            sx={{
              position: 'absolute',
              top: '10px',
              right: '10px',
            }}
            onClick={handleClose}
            size="small"
            color="primary"
            aria-label="add"
          >
            <CloseIcon />
          </Fab>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                fontSize: '24px',
                fontWeight: 700,
                color: '#3D71FF',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                paddingRight: '60px',
              }}
            >
              {data === null
                ? `New Event`
                : isDisplay
                ? `Event (${data?.code || ''} - ${data?.name || ''})`
                : `Update Event (${data?.code || ''} - ${data?.name || ''})`}
            </Typography>
          </div>
          <div
            style={{ display: 'flex', gap: '24px', marginTop: '16px', alignItems: 'center', justifyContent: 'center' }}
          >
            <span style={{ fontSize: '20px', fontWeight: 700, color: currentStep === 1 ? '#3D71FF' : '#c1c1c1' }}>
              General
            </span>
            <div
              style={{
                width: '12px',
                height: '12px',
                backgroundColor: '#3D71FF',
                borderRadius: '50%',
                border: '1px solid #3D71FF',
              }}
            />
            <span style={{ fontSize: '20px', fontWeight: 700, color: currentStep === 2 ? '#3D71FF' : '#c1c1c1' }}>
              Notification
            </span>
            <div
              style={{
                width: '12px',
                height: '12px',
                backgroundColor: '#3D71FF',
                borderRadius: '50%',
                border: '1px solid #3D71FF',
              }}
            />
            <span style={{ fontSize: '20px', fontWeight: 700, color: currentStep === 3 ? '#3D71FF' : '#c1c1c1' }}>
              Attachment
            </span>
          </div>
          {/* currentStep - 1 */}
          {currentStep === 1 && (
            <div className="sm-flex-direction-column" style={{ display: 'flex', gap: '24px', marginTop: '32px' }}>
              {/* Right Side */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', flex: '1 1 0%' }}>
                {/* name */}
                <TextField
                  disabled={isDisableAll}
                  value={fieldValue.name}
                  onChange={(e) => setFieldValue({ ...fieldValue, name: e.target.value })}
                  label={
                    <Typography sx={{ color: '#B6B6B6' }}>
                      Name <span style={{ color: 'red' }}>*</span>
                    </Typography>
                  }
                  size="small"
                  type="text"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    style: { color: 'black' },
                    // shrink: true,
                  }}
                  error={fieldValueError?.find((e) => e.key === 'name')}
                  helperText={fieldValueError?.find((e) => e.key === 'name')?.error}
                  inputProps={{
                    maxLength: 250,
                    maxlength: 250,
                  }}
                />
                <div style={{ display: 'flex', gap: '24px', justifyContent: 'space-between' }}>
                  {/* eventType */}
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ color: '#c1c1c1', fontSize: '16px' }}>Mode of Invitation</span>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Radio
                          disabled={isDisableAll}
                          checked={fieldValue.eventType === 'Private'}
                          onChange={() =>
                            setFieldValue({
                              ...fieldValue,
                              eventType: 'Private',
                            })
                          }
                          value="Private"
                          name="eventType-radio-buttons"
                        />
                        <span>Private</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Radio
                          disabled={isDisableAll}
                          checked={fieldValue.eventType === 'Public'}
                          onChange={() =>
                            setFieldValue({
                              ...fieldValue,
                              eventType: 'Public',
                            })
                          }
                          value="Public"
                          name="eventType-radio-buttons"
                        />
                        <span>Public</span>
                      </div>
                    </div>
                  </div>
                  {/* status */}
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ color: '#c1c1c1', fontSize: '16px' }}>Status</span>
                    <Switch
                      style={{ color: '#2065d1' }}
                      disabled={isDisableAll}
                      checked={fieldValue.status === 'Active'}
                      // sx={{
                      //   marginRight: '16px',
                      // }}
                      onChange={(e) =>
                        setFieldValue((prev) => ({
                          ...prev,
                          status: e.target.checked ? 'Active' : 'Inactive',
                        }))
                      }
                    />
                  </div>
                </div>
                {/* date */}
                <DateField
                  disablePast
                  disabled={isDisableAll}
                  value={fieldValue.date}
                  fullWidth
                  variant="outlined"
                  label={
                    <Typography sx={{ color: '#B6B6B6' }}>
                      Date <span style={{ color: 'red' }}>*</span>
                    </Typography>
                  }
                  onChange={(e) => e?.isValid() && setFieldValue((prev) => ({ ...prev, date: e.toISOString() }))}
                  error={fieldValueError?.find((e) => e.key === 'date')}
                  helperText={fieldValueError?.find((e) => e.key === 'date')?.error}
                />
                {/* recurringEvent */}
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                  <Checkbox
                    disabled={isDisableAll}
                    checked={fieldValue.recurringEvent}
                    onChange={(e) =>
                      setFieldValue({
                        ...fieldValue,
                        frequency: '',
                        interval: 1,
                        recurringEvent: e.target.checked,
                      })
                    }
                  />
                  <span>Recurring event</span>
                </div>
                {/* frequency - interval */}
                {fieldValue.recurringEvent && (
                  <div style={{ display: 'flex', gap: '8px' }}>
                    {/* frequency */}
                    <div style={{ flex: '1 1 0%' }}>
                      <TextField
                        disabled={isDisableAll}
                        value={fieldValue.frequency}
                        onChange={(e) => setFieldValue({ ...fieldValue, frequency: e.target.value })}
                        label={<Typography sx={{ color: '#B6B6B6' }}>Frequency</Typography>}
                        size="small"
                        type="text"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          style: { color: 'black' },
                          // shrink: true,
                        }}
                        inputProps={{
                          maxLength: 250,
                          maxlength: 250,
                        }}
                        select
                      >
                        <MenuItem value="day">Day</MenuItem>
                        <MenuItem value="week">Week</MenuItem>
                        <MenuItem value="month">Month</MenuItem>
                        <MenuItem value="year">Year</MenuItem>
                      </TextField>
                    </div>
                    {/* interval */}
                    <div style={{ flex: '1 1 0%' }}>
                      <TextField
                        disabled={isDisableAll}
                        value={fieldValue.interval}
                        onChange={(e) => setFieldValue({ ...fieldValue, interval: e.target.value })}
                        label={<Typography sx={{ color: '#B6B6B6' }}>Interval</Typography>}
                        size="small"
                        type="number"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          style: { color: 'black' },
                          // shrink: true,
                        }}
                        error={fieldValueError?.find((e) => e.key === 'interval')}
                        helperText={fieldValueError?.find((e) => e.key === 'interval')?.error}
                      />
                    </div>
                  </div>
                )}
              </div>
              {/* Left Side */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', flex: '1 1 0%' }}>
                {/* type */}
                <CustomSimpleSelect
                  variant="outlined"
                  disabled={isDisableAll}
                  label={
                    <Typography sx={{ color: '#B6B6B6' }}>
                      Event Type <span style={{ color: 'red' }}>*</span>
                    </Typography>
                  }
                  value={fieldValue.type}
                  onChange={(value) =>
                    setFieldValue({
                      ...fieldValue,
                      type: value || '',
                    })
                  }
                  valueKey="_id"
                  options={eventTypeList?.map((e) => ({
                    label: e?.name,
                    ...e,
                  }))}
                  error={fieldValueError?.find((e) => e.key === 'type')}
                  helperText={fieldValueError?.find((e) => e.key === 'type')?.error}
                />
                {/* description */}
                <TextField
                  disabled={isDisableAll}
                  value={fieldValue.description}
                  onChange={(e) => setFieldValue({ ...fieldValue, description: e.target.value })}
                  label={<Typography sx={{ color: '#B6B6B6' }}>Description</Typography>}
                  size="small"
                  type="text"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    style: { color: 'black' },
                    // shrink: true,
                  }}
                  multiline
                  rows={4}
                  inputProps={{
                    maxLength: 500,
                    maxlength: 500,
                  }}
                  error={fieldValueError?.find((e) => e.key === 'description')}
                  helperText={fieldValueError?.find((e) => e.key === 'description')?.error}
                />
                {/* budget */}
                <TextField
                  disabled={isDisableAll}
                  value={fieldValue.budget}
                  onChange={(e) => {
                    const inputValue = e.target.value;

                    // Use a regular expression to allow only numbers (0-9) and optionally a single decimal point.
                    // If you only want integers, use: /[^0-9]/g
                    const numericValue = inputValue.replace(/[^0-9.]/g, '');

                    // Optional: To prevent multiple decimal points
                    const parts = numericValue.split('.');
                    if (parts.length > 2) {
                      // If there are more than two parts, it means multiple decimals.
                      // Take the first part and the first character after the first decimal.
                      setFieldValue({ ...fieldValue, budget: `${parts[0]}.${parts.slice(1).join('')}` });
                    } else {
                      setFieldValue({ ...fieldValue, budget: numericValue });
                    }
                  }}
                  label={<Typography sx={{ color: '#B6B6B6' }}>Budget</Typography>}
                  size="small"
                  type="text"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    style: { color: 'black' },
                    // shrink: true,
                  }}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">{amountSym}</InputAdornment>,
                  }}
                  error={fieldValueError?.find((e) => e.key === 'budget')}
                  helperText={fieldValueError?.find((e) => e.key === 'budget')?.error}
                />
              </div>
            </div>
          )}
          {currentStep === 2 && (
            <div className="sm-flex-direction-column" style={{ display: 'flex', gap: '24px', marginTop: '32px' }}>
              {/* Right Side */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', flex: '1 1 0%' }}>
                <span style={{ fontSize: '16px', color: '#2b3674', fontWeight: 'bold' }}>
                  Select your preferred notification method
                </span>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '32px' }}>
                  {/* email */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <Switch
                      style={{ color: '#2065d1' }}
                      disabled={isDisableAll}
                      checked={fieldValue.notification.email}
                      onChange={() =>
                        setFieldValue((prev) => ({
                          ...prev,
                          notification: { ...prev.notification, email: !prev.notification.email },
                        }))
                      }
                    />
                    <span>E-Mail</span>
                  </div>
                  {/* text */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <Switch
                      style={{ color: '#2065d1' }}
                      disabled={isDisableAll}
                      checked={fieldValue.notification.text}
                      onChange={() =>
                        setFieldValue((prev) => ({
                          ...prev,
                          notification: { ...prev.notification, text: !prev.notification.text },
                        }))
                      }
                    />
                    <span>Text</span>
                  </div>
                  {/* notification */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <Switch
                      style={{ color: '#2065d1' }}
                      disabled={isDisableAll}
                      checked={fieldValue.notification.notification}
                      onChange={() =>
                        setFieldValue((prev) => ({
                          ...prev,
                          notification: { ...prev.notification, notification: !prev.notification.notification },
                        }))
                      }
                    />
                    <span>Notification Screen</span>
                  </div>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '32px' }}>
                  {/* mobileApp */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <Switch
                      style={{ color: '#2065d1' }}
                      disabled={isDisableAll}
                      checked={fieldValue.notification.mobileApp}
                      onChange={() =>
                        setFieldValue((prev) => ({
                          ...prev,
                          notification: { ...prev.notification, mobileApp: !prev.notification.mobileApp },
                        }))
                      }
                    />
                    <span>Mobile App</span>
                  </div>
                  {/* banner */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <Switch
                      style={{ color: '#2065d1' }}
                      disabled={isDisableAll}
                      checked={fieldValue.notification.banner}
                      onChange={() =>
                        setFieldValue((prev) => ({
                          ...prev,
                          notification: { ...prev.notification, banner: !prev.notification.banner },
                        }))
                      }
                    />
                    <span>Notification Banner</span>
                  </div>
                </div>
              </div>
            </div>
          )}
          {currentStep === 3 && (
            <div className="sm-flex-direction-column" style={{ display: 'flex', gap: '24px', marginTop: '32px' }}>
              {/* Right Side */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', flex: '1 1 0%' }}>
                <span style={{ fontSize: '16px', color: '#2b3674', fontWeight: 'bold' }}>Event Location</span>
                {/* venue */}
                <TextField
                  disabled={isDisableAll}
                  value={fieldValue.venue}
                  onChange={(e) => setFieldValue({ ...fieldValue, venue: e.target.value })}
                  label={<Typography sx={{ color: '#B6B6B6' }}>Venue</Typography>}
                  size="small"
                  type="text"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    style: { color: 'black' },
                    // shrink: true,
                  }}
                  error={fieldValueError?.find((e) => e.key === 'venue')}
                  helperText={fieldValueError?.find((e) => e.key === 'venue')?.error}
                  inputProps={{
                    maxLength: 250,
                    maxlength: 250,
                  }}
                />
                <span style={{ fontSize: '16px', color: '#2b3674', fontWeight: 'bold' }}>Event Image</span>
                {/* eventImage */}
                <TextField
                  onChange={(e) => {
                    if (!e?.target?.files[0]?.name?.match(/\.(jpg|jpeg|png)$/)) {
                      toast.error('Please select a valid file in JPG, JPEG, PNG, Format ONLY.');
                    } else {
                      setImagesFile(e.target.files[0]);
                    }
                  }}
                  // label={<Typography sx={{ color: '#B6B6B6' }}>Event Image</Typography>}
                  type="file"
                  size="small"
                  id="upload-file-invoiceFile"
                  fullWidth
                  variant="outlined"
                  disabled={isDisableAll}
                  InputProps={{
                    accept: 'image/*',
                  }}
                  InputLabelProps={{
                    style: { color: 'black' },
                    shrink: true,
                  }}
                />
                <FileImageView
                  file={imagesFile}
                  url={fieldValue.eventImage?.[0] || ''}
                  onRemove={() => {
                    setImagesFile(null);
                    setFieldValue({ ...fieldValue, eventImage: [] });
                    const ele = document.getElementById('upload-file-invoiceFile');
                    if (ele) {
                      ele.value = null;
                    }
                  }}
                />
              </div>
              {/* Left Side */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', flex: '1 1 0%' }}>
                {/* locationUrl */}
                <TextField
                  sx={{ mt: '38px' }}
                  disabled={isDisableAll}
                  value={fieldValue.locationUrl}
                  onChange={(e) => setFieldValue({ ...fieldValue, locationUrl: e.target.value })}
                  label={<Typography sx={{ color: '#B6B6B6' }}>Google Location URL</Typography>}
                  size="small"
                  type="text"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    style: { color: 'black' },
                    // shrink: true,
                  }}
                  error={fieldValueError?.find((e) => e.key === 'locationUrl')}
                  helperText={fieldValueError?.find((e) => e.key === 'locationUrl')?.error}
                  inputProps={{
                    maxLength: 250,
                    maxlength: 250,
                  }}
                />
              </div>
            </div>
          )}

          <div style={{ display: 'flex', gap: '12px', marginTop: '22px', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', gap: '12px' }}>
              {/* syncWithSafalMyBuy */}
              {globalToggleState?.syncWithSafalMyBuy === 'YES' && (
                <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                  <Checkbox
                    disabled={!safalMyBuyState?.id ? true : isDisableAll}
                    checked={syncWithSafalMyBuy}
                    onChange={(e) => setSyncWithSafalMyBuy(e.target.checked)}
                  />
                  <span
                    style={{
                      color: !safalMyBuyState?.id ? '#b2bbc4' : isDisableAll ? '#b2bbc4' : 'black',
                    }}
                  >
                    Sync With SafalMyBuy
                  </span>
                </div>
              )}
            </div>
            <div style={{ display: 'flex', gap: '12px', flex: 'none' }}>
              <Button
                disabled={isDisplay ? false : isDisableAll}
                sx={{
                  backgroundColor: '#ff4842',
                  ':hover': { backgroundColor: '#d40700' },
                  color: 'white',
                  borderRadius: '30px',
                  textTransform: 'capitalize',
                  minWidth: '100px',
                }}
                onClick={handleClose}
                variant="contained"
              >
                Cancel
              </Button>
              {currentStep > 1 && (
                <Button
                  sx={{
                    backgroundColor: '#3D71FF',
                    borderRadius: '30px',
                    textTransform: 'capitalize',
                    minWidth: '100px',
                  }}
                  onClick={() => setCurrentStep((prev) => prev - 1)}
                  variant="contained"
                  disabled={isDisplay ? false : isDisableAll}
                >
                  Previous
                </Button>
              )}
              {currentStep !== 3 && (
                <Button
                  sx={{
                    backgroundColor: '#3D71FF',
                    borderRadius: '30px',
                    textTransform: 'capitalize',
                    minWidth: '100px',
                  }}
                  onClick={() => onNextPage(currentStep)}
                  variant="contained"
                  disabled={isDisplay ? false : isDisableAll}
                >
                  Next
                </Button>
              )}
              {currentStep === 3 && !isDisplay && data === null && (
                <Button
                  disabled={isDisableAll}
                  onClick={onSubmit}
                  sx={{
                    backgroundColor: '#3D71FF',
                    borderRadius: '30px',
                    textTransform: 'capitalize',
                    minWidth: '100px',
                  }}
                  variant="contained"
                >
                  Add
                </Button>
              )}
              {!isDisplay && data !== null && (
                <Button
                  disabled={isDisableAll}
                  onClick={onUpdate}
                  sx={{
                    backgroundColor: '#3D71FF',
                    borderRadius: '30px',
                    textTransform: 'capitalize',
                    minWidth: '100px',
                  }}
                  variant="contained"
                >
                  Save
                </Button>
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}
